import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// OPTIMIZACIÓN 1 y 4: Imagen WebP optimizada + Cadena crítica reducida
if (typeof window !== 'undefined') {
  // 1. PRIORIDAD MÁXIMA: Preload imagen LCP WebP (<50KB)
  const preloadLCP = document.createElement('link');
  preloadLCP.rel = 'preload';
  preloadLCP.as = 'image';
  preloadLCP.href = 'https://cdn.magicpatterns.com/uploads/3kRHffD2vVFMHbK8ojt2we/mockup_webp_(2).webp';
  preloadLCP.type = 'image/webp';
  preloadLCP.fetchPriority = 'high';
  document.head.insertBefore(preloadLCP, document.head.firstChild);
  // 2. OPTIMIZACIÓN 2: Cache-Control hint para CDN (1 año)
  // Nota: El servidor debe configurar: Cache-Control: public, max-age=31536000
  const preconnectCDN = document.createElement('link');
  preconnectCDN.rel = 'preconnect';
  preconnectCDN.href = 'https://cdn.magicpatterns.com';
  preconnectCDN.crossOrigin = 'anonymous';
  document.head.appendChild(preconnectCDN);
  // 3. OPTIMIZACIÓN 3: Google Fonts asíncrono con display=swap
  const loadFonts = () => {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    // &display=swap añadido para evitar bloqueo de renderizado
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap';
    fontLink.media = 'print';
    fontLink.onload = function () {
      this.media = 'all';
    };
    // Carga asíncrona para no bloquear renderizado
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => {
        document.head.appendChild(fontLink);
      }, {
        timeout: 500
      });
    } else {
      setTimeout(() => {
        document.head.appendChild(fontLink);
      }, 0);
    }
  };
  // Cargar fuentes después del contenido crítico
  if (document.readyState === 'complete') {
    loadFonts();
  } else {
    window.addEventListener('load', loadFonts, {
      once: true,
      passive: true
    });
  }
  // Noscript fallback
  const noscript = document.createElement('noscript');
  const fallbackLink = document.createElement('link');
  fallbackLink.rel = 'stylesheet';
  fallbackLink.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap';
  noscript.appendChild(fallbackLink);
  document.head.appendChild(noscript);
}
// Render app
render(<App data-id="element-219" />, document.getElementById('root'));